/**
 * Formate une liste de prénoms pour l'en-tête « Mon solde » :
 *   - jusqu'à 4 noms → « Yann, Michel, Blandine et Gerry »
 *   - au-delà       → « Yann, Michel, Blandine et 3 autres »
 */
export const formatNameList = (
  names: string[],
  moreLabel: (count: number) => string,
  conjunction: string
): string => {
  const cleaned = names.filter(Boolean);
  if (cleaned.length === 0) return '';
  if (cleaned.length === 1) return cleaned[0];

  const items =
    cleaned.length <= 4 ? cleaned : [...cleaned.slice(0, 3), moreLabel(cleaned.length - 3)];
  const last = items[items.length - 1];
  const rest = items.slice(0, -1).join(', ');
  return `${rest} ${conjunction} ${last}`;
};
